module.exports = __webpack_public_path__ + "img/1e3a00c.png";